export default "__VITE_ASSET__BFgiz9i$__"